<!--
  File name: Landing.vue
  Program Description:
    - This is the component for the landing page in Dashboard after login
    - This contains the ff
      * Name of the logged in user
      * DBNMS header and image
      * Shortcut button for creating PDBNF and ASIR for PIC users
      * Self Assessment form for PIC users

  Includes:
    - SelfAssessmentForm: this component is displayed for PIC users only
-->
<template>
  <v-container>
    <h1
      class="my-3"
    >
      Hello, {{ fullName }}!
    </h1>
    <v-card>
      <v-container
        fluid
        class="py-5"
      >
        <v-row>
          <v-col
            cols="6"
            class="mx-3"
          >
            <v-card-title
              class="primary--text"
            >
              <h3>{{ header }}</h3>
            </v-card-title>
            <v-card-subtitle>
              {{ description }}
            </v-card-subtitle>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            class="d-flex align-center justify-center"
          >
            <v-img
              max-height="500"
              max-width="480"
              :src="`${cardImage}`"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            v-if="isPic"
            class="text-center"
          >
            <router-link
              to="/admin/dataBreach/pdbnf/create"
            >
              <v-btn
                x-large
                width="450"
                color="#E9C034"
                class="white--text border--radius ma-3"
              >
                Create PDBN
                <v-tooltip
                  max-width="400"
                  top
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="white"
                      class="ml-2"
                      depressed
                      v-bind="attrs"
                      v-on="on"
                    >
                      mdi-information
                    </v-icon>
                  </template>
                  <span>Personal Data Breach Notification Form - for submitting data breach notifications</span>
                </v-tooltip>
              </v-btn>
            </router-link>
            <router-link
              to="/admin/securityIncident/asir/create"
            >
              <v-btn
                x-large
                width="450"
                outlined
                color="#E9C034"
                class="border--radius ma-3"
              >
                Create ASIR
                <v-tooltip
                  max-width="400"
                  top
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="#E9C034"
                      class="ml-2"
                      depressed
                      v-bind="attrs"
                      v-on="on"
                    >
                      mdi-information
                    </v-icon>
                  </template>
                  <span>Annual Security Incident Report</span>
                </v-tooltip>
              </v-btn>
            </router-link>
          </v-col>
        </v-row>
        <v-row
          class="text-center"
        >
          <v-col
            v-if="isPic"
          >
            <p>
              Unsure of what form to create? Undergo
              <a
                class="amber--text font-weight-black"
                @click="openDialog"
              >
                Self Assessment here
              </a>
            </p>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <SelfAssessmentForm
      v-model="showDialog"
    />
  </v-container>
</template>

<script>
import SelfAssessmentForm from './SelfAssessmentForm'

export default {
  name: 'Landing',
  components: {
    SelfAssessmentForm
  },
  props: {
    fullName: {
      type: String,
      default: ''
    },
    isPic: {
      type: Boolean,
      default: false
    },
    header: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    cardImage: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    showDialog: false
  }),
  methods: {
    openDialog () {
      this.showDialog = true
    }
  }
}
</script>

<style scoped>
  .border--radius {
    border-radius: 8px;
  }
</style>
